import angular from 'angular';

import { UnitFavoriteBtnCtrl } from './unitFavoriteBtn.controller';

import './unitFavoriteBtn.scss';

export default angular
  .module('unit-favorite-btn', [])
  .directive('unitFavoriteBtn', () => ({
    restrict: 'A',
    controller: UnitFavoriteBtnCtrl,
    controllerAs: 'favoritesVm',
    bindToController: true,
  }));
